<i
    class="far fa-magnifying-glass-plus"
    matTooltip="Zoom"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
    (contextmenu)="$event.preventDefault()"
    draggable="false"
></i>
